import Api from "../../api/index";
import idb from "../../idb/done_forms";

const DoneForm = {
  namespaced: true,
  state: {
    value: "my value",

    oneDoneForm: null, //to store SHOW response
    allDoneForms: [], //to store SHOW response
    counters: {
      to_approve: 0,
      to_review: 0,
      concluded: 0,
      reproved: 0
    },

    loading_done_forms: false,

    //promises results
    createDoneFormWasGood: null,
    createDoneFormMessage: null,
    //corona
    last_score: null,

    updateDoneFormWasGood: null,
    updateDoneFormMessage: null,

    // less used
    indexDoneFormWasGood: null,
    indexDoneFormMessage: null,

    showDoneFormWasGood: null,
    showDoneFormMessage: null,
  },
  getters: {
    getStateValue: (state) => {
      return state.value;
    },
    getLastScore: (state) => {
      return state.last_score;
    },
  },

  mutations: {
    setOneDoneForm(state, DoneForm) {
      state.oneDoneForm = DoneForm.data.attributes; // DoneForm.data
    },
    setAllDoneForms(state, DoneForms) {
      state.allDoneForms = DoneForms.map((obj) => obj.attributes); // DoneForms.data
    },

    createResponse(state, {was_good, msg, done_form}){
      state.createDoneFormWasGood = was_good
      state.createDoneFormMessage = msg
      if (done_form && done_form.score){
        state.last_score = Number(done_form.score)
      }
      setTimeout(() => {
        state.createDoneFormWasGood = null;
      }, 100);
    },
    updateResponse(state, { was_good, msg }) {
      state.updateDoneFormWasGood = was_good;
      state.updateDoneFormMessage = msg;
      setTimeout(() => {
        state.updateDoneFormWasGood = null;
      }, 100);
    },
    indexResponse(state, { was_good, msg }) {
      state.indexDoneFormWasGood = was_good;
      state.indexDoneFormMessage = msg;
      setTimeout(() => {
        state.indexDoneFormWasGood = null;
      }, 100);
    },
    showResponse(state, { was_good, msg }) {
      state.showDoneFormWasGood = was_good;
      state.showDoneFormMessage = msg;
      setTimeout(() => {
        state.showDoneFormWasGood = null;
      }, 100);
    },

    setLoadingDoneForms(state, val){
      state.loading_done_forms = val
    },

    clearAllDoneForms(state) {
      state.allDoneForms = null;
    },
    clearOneDoneForm(state) {
      state.oneDoneForm = null;
    },
    setCounters(state, counters) {
      const keys = Object.keys(state.counters);
      keys.forEach((key) => {
        state.counters[key] = counters[key] ? counters[key] : 0
      })
    }
  },

  actions: {
    indexCounters({commit}, filter) {
      return Api.DoneForm.indexCounters(filter).then((r) => r.data).then((r) => {
        commit('setCounters', {...r})
        return r;
      }).catch((error) => {
        console.log(`Erro: ${error}`);
      })
    },
    clearAllDoneForms({ commit }) {
      commit("clearAllDoneForms");
    },
    clearOneDoneForm({ commit }) {
      commit("clearOneDoneForm");
    },

    index(context, filter) {
      context.commit('setLoadingDoneForms', true)
      return Api.DoneForm.index(filter)
        .then((response) => response.data)
        .then((r) => {
          // console.log(DoneForms);
          context.commit("setAllDoneForms", r.data);
          context.commit("indexResponse", { msg: "", was_good: true });
          return r;
        })
        .catch(function(error) {
          console.log("error => ", error)
          context.commit("indexResponse", {
            msg: error.response.data,
            was_good: false,
          });
          // auto-comment// console.log(error);
        }).finally(()=>{
          context.commit('setLoadingDoneForms', false)
        })
    },
    indexCompleted(context, filter) {
      const ACTION = filter.state == 'to_approve' ? 'indexToApprove' : 'indexCompleted';

      context.commit('setLoadingDoneForms', true)
      return Api.DoneForm[ACTION](filter)
        .then((response) => response.data)
        .then((r) => {
          // console.log(DoneForms);
          context.commit("setAllDoneForms", r.data);
          context.commit("indexResponse", { msg: "", was_good: true });
          // context.commit("setCounters", r.counters);
          return r;
        })
        .catch(function(error) {
          console.log("error => ", error)
          context.commit("indexResponse", {
            msg: error.response.data,
            was_good: false,
          });
          // auto-comment// console.log(error);
        }).finally(()=>{
          context.commit('setLoadingDoneForms', false)
        })
    },
    show(context, {id, filter}) {
      Api.DoneForm.show(id, filter)
        .then((response) => response.data)
        .then((DoneForm) => {
          context.commit("setOneDoneForm", DoneForm);
          context.commit("showResponse", { msg: "", was_good: true });
        })
        .catch(function(error) {
          context.commit("showResponse", {
            msg: error.response.data.errors[0],
            was_good: false,
          });
          // auto-comment// console.log(error);
        });
    },
    create(context, new_DoneForm) {
      if(!new_DoneForm.done_at) new_DoneForm.done_at = new Date();
      return Api.DoneForm.create(new_DoneForm)
        .then(response => response.data)
        .then(DoneForm => {
          // context.commit('setOneDoneForms', DoneForm); // not often used
          context.commit('createResponse', {msg: '', was_good: true, done_form: DoneForm});
          return DoneForm
        }).catch(function(error) {
             // auto-comment// console.log(error);
          context.commit('createResponse', {msg: '', was_good: false});
          idb.store_done_form(new_DoneForm)

        });
    },
    update(context, DoneForm) {
      return Api.DoneForm.update(DoneForm)
        .then(response => response.data)
        .then(DoneForm => {
          // context.commit('setOneDoneForm', DoneForm); // not often used
          context.commit('updateResponse', {msg: '', was_good: true});
          return DoneForm
        }).catch(function(error) {
          context.commit('updateResponse', {msg: error.response.data.errors[0], was_good: false});
             // auto-comment// console.log(error);
        });
    },
    updateToDelete(context, DoneForm) {
      Api.DoneForm.updateToDelete(DoneForm)
        .then((response) => response.data)
        .then((DoneForm) => {
          // context.commit('setOneDoneForm', DoneForm); // not often used
          context.commit("updateResponse", {
            msg: "Apagado com sucesso",
            was_good: true,
          });
        })
        .catch(function(error) {
          context.commit("updateResponse", { msg: error, was_good: false });
          // auto-comment// console.log(error);
        });
    },
  },
};

export default DoneForm;
